<template>
    <div>
        <el-dialog
            :title="$t('paper.mock') +' - '+ (mockData?mockData.mockPaperName:'')"
            :visible.sync="visible"
            custom-class="mockList-dialog"
            width="900px"
            top="10vh"
            :close-on-click-modal="false"
            :append-to-body="false"
            :modal-append-to-body="false"
        >
            <p class="mock-info" v-if="mockData">
                <span>{{$t('paper.mockTimes')}}：{{mockData.times}}</span>
                <span>{{$t('topic.rightRate')}}：{{(mockData.avgAccuracy * 100).toFixed(2) + '%'}}</span>
                <span>{{$t('count.passRate')}}：{{(mockData.passingRate * 100).toFixed(2) + '%'}}</span>
                <span>{{$t('count.averageScore')}}：{{(mockData.avgScore).toFixed(2)}}</span>
            </p>
            <el-table class="mock-table"
                      ref="mockTable"
                      :data="mockTableData"
                      :border="false"
                      :stripe="true"
                      height="500"
            >
                <el-table-column
                    type="index" align="center" label="#"
                    :index="1">
                </el-table-column>
                <!-- column title -->
                <el-table-column v-for="title in mockTitles" :prop="title.prop" :label="title.label"
                                 :key="title.label"
                                 align="center"
                                 :sortable="true">
                </el-table-column>
                <el-table-column :label="$t('paper.keyQuestion')" align="center" property="keyAccuracy" sortable>
                    <template slot-scope="scope">
                        <span>{{scope.row.keyAccuracy != null ? (Math.round(scope.row.keyAccuracy * 10000) / 100 + '%') : '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('stu.isPass')" align="center" property="isPass" :sortable="true">
                    <template slot-scope="scope">
                        <span class="tg-bg" :class="scope.row.isPass?'passed':'failed'">
                            {{ scope.row.isPass ? $t('count.passed') : $t('count.failed') }}
                        </span>
                    </template>
                </el-table-column>
                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center">
                    <div class="btn-cell" slot-scope="scope">
                        <el-button
                            :title="$t('c.view')"
                            size="mini"
                            type="success"
                            round
                            class="nucfont inuc-preview"
                            @click="viewMockPaper(scope.row)">
                        </el-button>
                    </div>
                </el-table-column>
            </el-table>
        </el-dialog>

        <paper-view
            v-if="paperShow"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        />

        <fiscan-paper
            ref="fiscanPaper"
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            type="mockExam"
            :usage="2"
        />

    </div>
</template>

<script>
import api from '@/api';
import {screenfull} from '@/utils';
import paperView from '@/components/Paper/PaperView';
import FiscanPaper from '@components/FiscanPaper'

export default {
    name: 'MockListDialog',
    components: {
        paperView,
        FiscanPaper
    },
    props: {
        dialogOpen: {
            type: Boolean,
            default: false,
        },
        mockItem: {
            type: Object
        }
    },
    data() {
        return {
            visible: false,
            mockData: null,
            mockTableData: [],
            mockTitles: [
                {
                    prop: 'total',
                    label: this.$t('stu.topicNum')
                }, {
                    prop: 'wrong',
                    label: this.$t('count.wrongNum')
                }, {
                    prop: 'paperScore',
                    label: this.$t('paper.totalScore')
                }, {
                    prop: 'score',
                    label: this.$t('count.score')
                },
            ],

            // 理论
            paperShow: false,
            paperInfo: {},
            topicData: [],

            // 图像
            isShow: false,
            src: '',
            // 职鉴
            fiscanPaper: {
                show: false,
                data: null
            }
        }
    },
    watch: {
        visible(val) {
            // 打开
            if (val) {
                this.initDialog();
            // 关闭
            } else {
                this.$emit('update:dialogOpen', false)
            }
        },
        dialogOpen() {
            this.visible = this.dialogOpen;
        }
    },
    methods: {
        initDialog() {
            let item = this.mockItem;
            api.getMockReport(item.id).then(res => {
                let data = res.package;
                this.mockData = data;
                this.mockData.mockPaperName = item.mockPaperName;
                this.mockTableData = data.items;
            })
        },
        viewMockPaper(data) {
            let {paperType, itemId} = data;
            if (paperType === 1) {
                screenfull.request();
                this.paperShow = true;

                api.mockExamHistory(itemId).then(res => {
                    let data = res.package;
                    this.topicData = data.paper.relationship;
                    this.paperInfo = {
                        response: data.records,
                        isSubmit: data.isSubmit,
                        score: data.score,
                        totalSeconds: data.totalSeconds,
                        ...data.paper,
                    };
                }).catch(error => {
                    this.paperShow = false;
                    screenfull.exit();
                });
            } else if (paperType === 3 || paperType === 4) {
                this.$emit('onViewImgMockPaper', {
                    paperType,
                    recordId: itemId
                })
            }else if (paperType === 5) {
                this.fiscanPaper.show = true
                api.mockExamHistory(itemId).then(res => {
                    this.fiscanPaper.data = res.package
                    // 因为职鉴预览里有dialog，且关闭dialog后，当前的遮罩层还会存在，所以在打开职鉴时要关闭当前页面
                    this.visible = false
                }).catch(() => {this.fiscanPaper.show = false})
            }
        },
        onPaperClose() {
            this.paperShow = false;
        },
        toggleIsShow (val) {
            this.isShow = val;
            this.src = null;
        },
    }
}
</script>

<style lang="scss">
    #viewPlanRecord,
    #myTaskDetail {
        .m-paperView {
            z-index: 3000;
        }
        .fiscan-paperView {
            z-index: 3000;
        }
    }

    .mockList-dialog {
        .mock-info {
            padding: 10px 20px;
            span {
                margin-right: 15px;
                color: $blue-dark;
            }
        }
    }
</style>
